import { fmtRelative, fmtTimeOfDay } from '../../lib/time.ts';
import { StalenessBadge } from '../common/StalenessBadge.tsx';

/** Last-updated clock (role=status) + manual refresh. Auto and manual refresh
 *  share the same handler; refreshing never moves focus. */
export function RefreshControl({
  lastUpdatedAt,
  isRefreshing,
  onRefresh,
  nowMs,
  anyStale,
}: {
  lastUpdatedAt: string | null;
  isRefreshing: boolean;
  onRefresh: () => void;
  nowMs: number;
  anyStale: boolean;
}) {
  return (
    <div className="refresh">
      <span className="refresh__clock" role="status">
        <span className="dim">Updated</span>{' '}
        <span data-numeric>{fmtTimeOfDay(lastUpdatedAt)}</span>{' '}
        <span className="dim">· {fmtRelative(lastUpdatedAt, nowMs)}</span> <StalenessBadge stale={anyStale} />
      </span>
      <button
        type="button"
        className="btn"
        aria-disabled={isRefreshing}
        aria-label="Refresh now"
        onClick={() => {
          if (!isRefreshing) onRefresh();
        }}
      >
        {isRefreshing ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
}
